import React from 'react';
import { STATUS_COLOR_MAP, REPORT_STATUSES } from '../Timeline/Timeline.helpers';
import { TextMedium } from '../../common/text';
import { RoundSquare, LegendItem, Legend } from '../Timeline/Legend.styles';

const filters = [
    {
        value: 'Available',
        color: STATUS_COLOR_MAP[REPORT_STATUSES.AVAILABLE],
    },
    {
        value: 'In Service',
        color: STATUS_COLOR_MAP[REPORT_STATUSES.IN_SERVICE],
    },
    {
        value: 'Stopped',
        color: STATUS_COLOR_MAP[REPORT_STATUSES.STOPPED],
    },
    {
        value: 'Alarm: Running',
        color: STATUS_COLOR_MAP[REPORT_STATUSES.ALARM_RUNNING],
    },
    {
        value: 'Curtailed',
        color: STATUS_COLOR_MAP[REPORT_STATUSES.CURTAILED],
    },
    {
        value: 'No comms',
        color: STATUS_COLOR_MAP[REPORT_STATUSES.NO_COMM],
    },
    {
        value: 'Stopped: Manual',
        color: STATUS_COLOR_MAP[REPORT_STATUSES.STOPPED_MANUAL],
    },
    {
        value: 'Alarm: Stopped',
        color: STATUS_COLOR_MAP[REPORT_STATUSES.ALARM_STOPPED],
    },
    {
        value: 'Item Duration',
        color: STATUS_COLOR_MAP[REPORT_STATUSES.DURATION],
    },
];

export const TurbineStatusLegend = () => (
    <Legend>
        {filters.map((filter) => (
            <LegendItem key={filter.value}>
                <RoundSquare color={filter.color} />
                <TextMedium>{filter.value}</TextMedium>
            </LegendItem>
        ))}
    </Legend>
);

TurbineStatusLegend.displayName = 'TurbineStatusLegend';
